import { useEffect } from "react";
import Button, { Button2 } from "../components/general/Button";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { auth, logout, uploadArt } from "../firebase";
import { useZustand } from "../zustand/store";
import TextField from "../components/general/TextField";
import { artSections, ownerData } from "../data/main.data";
import MadeByOlaBanner from "../components/BottomBanner/MadeByOlaBanner";
import showToast from "../components/Toast/Toast";

function Dashboard() {
  const {
    showDashboard,
    setShowDashboard,
    formName,
    setFormName,
    formDescription,
    setFormDescription,
    uploadStatus,
    setUploadStatus,
    selectedUploadSection,
    setSelectedUploadSection,
  } = useZustand();

  const [user] = useAuthState(auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (
      (user && user?.email === "olaoluwaadeyemo7@gmail.com") ||
      user?.email === ownerData.signInEmail
    ) {
      setShowDashboard(true);
    } else {
      setShowDashboard(false);
      navigate("/login");
    }
  }, [user]);

  function clearForm(e: any) {
    //image
    // e.target = null;
    //selected section
    setSelectedUploadSection("");
    //name form
    setFormName("");
    //description form
    setFormDescription("");
  }

  function validateForm(e: any) {
    let file = e.target[0]?.files[0];

    if (!file) {
      showToast("Uploaded an Image file");
    } else if (selectedUploadSection === "") {
      showToast("Select an Art Section");
    } else if (formName === "") {
      showToast("Type the Art Name");
    } else if (formDescription === "") {
      showToast("Type the Art Description");
    } else {
      return true;
    }

    return false;
  }

  function ArtSectionDiv({ name, onClick }: any) {
    return (
      <div
        className={`px-3 py-2 rounded-md font-boska text-center ${
          selectedUploadSection === name
            ? "font-black border-2 border-gray-700"
            : "font-light border border-gray-500"
        }`}
        onClick={() => onClick()}
      >
        {name}
      </div>
    );
  }

  return (
    <div className="py-2 px-3 md:px-10 w-full min-h-screen flex flex-col justify-start items-center">
      {!showDashboard ? (
        <h1 className="text-3xl md:text-5xl font-black text-black font-boska text-center">
          Verifying Identity!
        </h1>
      ) : (
        <div>
          <h1 className="text-3xl md:text-5xl font-black text-black font-boska text-center">
            Dashboard!
          </h1>
          <div className="flex justify-center items-center gap-5">
            <Button text="Home" onClick={() => navigate("/")} />
            <Button text="Logout" onClick={() => logout()} />
          </div>

          {/*Upload Image Form*/}
          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (validateForm(e)) {
                //first make sure all form items are filled
                uploadArt(
                  e,
                  formName,
                  formDescription,
                  selectedUploadSection,
                  (val: any) => setUploadStatus(val)
                ).then(() => {
                  clearForm(e);
                });
              }
            }}
            className="form mt-10"
          >
            <div className="flex flex-col justify-start items-center gap-5">
              <input type="file" accept="image/*" />

              <p className="font-boska font-light">
                What Section should this post go in: (Select one)
              </p>

              <div className="flex-col justify-start items-center gap-y-5">
                {artSections.map((section, index) => {
                  return (
                    <ArtSectionDiv
                      key={index}
                      name={section.name}
                      onClick={() => setSelectedUploadSection(section.name)}
                    />
                  );
                })}
              </div>

              <TextField
                value={formName}
                handleChange={(val: String) => setFormName(val)}
                placeholder="Art Name"
              />
              <TextField
                value={formDescription}
                handleChange={(val: String) => setFormDescription(val)}
                placeholder="Art Description"
              />
              <p className="text-xl md:text-3xl font-black text-black font-boska text-center mt-2">
                {uploadStatus}
              </p>
              <button type="submit">
                <Button2 text="Upload Art!" />
              </button>
              <div className="flex justify-center pt-2">
                <MadeByOlaBanner />
              </div>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}

export default Dashboard;
